<template>
  <div class="create-record">
    <div class="headLine">
      <img src="../leftAngle.png" alt="返回" @click="backIndex"/>
      {{title}}
    </div>
    <div class="form-wrapper">
      <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="100px"
        label-position="right"
      >
        <el-form-item label="药品名称：" prop="medicineName">
          <el-input v-model="dataForm.medicineName" />
        </el-form-item>
        <el-form-item label="药品编码：" prop="medicineNumber">
          <el-input v-model="dataForm.medicineNumber" />
        </el-form-item>
        <el-form-item label="生产厂家：" prop="manufacturer">
          <el-input v-model="dataForm.manufacturer" />
        </el-form-item>
        <el-form-item label="检测项目：" prop="testItem">
          <el-input v-model="dataForm.testItem" />
        </el-form-item>
        <el-form-item label="安全风险等级：" prop="riskGrade">
          <el-input-number v-model="dataForm.riskGrade" :min="0" :step="1" :precision="0" />
        </el-form-item>
      </el-form>
    </div>
    <div class="form-submit">
      <el-button type="warning">出库</el-button>
      <el-button type="primary">入库</el-button>
      <el-button :disabled="btnDisabled">
          <span v-if="isCreate"
                @click.prevent="confirm">
                      确定
                  </span>
          <span v-else-if="!isCreate"
                @click.prevent="save">
              保存
          </span>
      </el-button>
      <div class="tips"></div>
    </div>
  </div>
</template>

<script>

    export default {
        data() {
            return {
                isCreate: true,
                title: '',
                dataForm: {
                    medicineName: '次氯酸钠',  //药品名称
                    medicineNumber: '011',  //药品编码
                    manufacturer: '广州明矾生物科技有限公司',  //生产厂家
                    testItem: '水质',  //检测项目
                    riskGrade: 3,  //安全风险等级
                },
                dataRule: {
                    medicineName: [
                        {required: true, message: '请输入药品名称', trigger: 'blur'}
                    ],
                    medicineNumber: [
                        {required: true, message: '请输入药品编码', trigger: 'blur'}
                    ],
                    manufacturer: [
                        {required: true, message: '请输入生产厂家', trigger: 'blur'}
                    ],
                    testItem: [
                        {required: true, message: '请输入检测项目', trigger: 'blur'}
                    ],
                    riskGrade: [
                        {required: true, message: '请输入安全风险等级', trigger: 'blur'}
                    ],
                },
                btnDisabled: false
            }
        },
        components: {},
        methods: {
            getType() {
                // eval(a.toLowerCase()) 将a转为Boolean类型的
                if ((typeof this.$route.query.isCreate) !== 'boolean') {
                    this.isCreate = eval(this.$route.query.isCreate.toLowerCase())
                } else {
                    this.isCreate = this.$route.query.isCreate
                }
                if (this.isCreate === true) {
                    this.title = '新增药品信息';
                } else {
                    this.title = '修改药品信息';
                }
            },
            // 返回
            backIndex() {
                this.$router.push({name: 'medicineMessage'})
            },
            //确定
            confirm() {},
            //保存
            save() {},

        },
        created() {
            this.$nextTick(() => {
                this.getType()
            })
        }
    }
</script>

<style lang="scss">
    @import '@/assets/style/global.scss';

    .create-record {
        width: 100%;
        padding: 50px 0 0;
        background: #fff;

        .headLine {
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            background-color: #fff;
            height: 50px;
            color: #000;
            font-weight: 600;
            text-align: center;
            line-height: 50px;
            font-size: 16px;
            z-index: 99;
            border-bottom: 1px #efefef solid;

            img {
                height: 30px;
                margin: 10px 0;
                padding: 0 10px;
                position: absolute;
                left: 0;
                top: 0;
            }
        }

        .form-wrapper {
            margin-bottom: 70px;
            .el-form {
                padding: 30px 15px 15px;

                .el-form-item {
                    margin-bottom: 30px;
                }
            }
        }

        .form-submit {
            position: fixed;
            left: 0px;
            bottom: 0px;
            text-align: center;
            width: 100%;
            background-color: #fff;
            z-index: 99;
            border-top: 1px #efefef solid;

            button {
                width: 80%;
                height: 4rem;
                margin: 10px 0;
                background-color: #67c23a;
                font-size: 1.6rem;
                font-weight: bold;

                &:hover,
                &:active {
                    color: #fff;
                }
            }
        }
    }

</style>
